import { Outlet, Routes, Route, Navigate } from 'react-router-dom';

import EditProductForm from './forms/edit';
import NewProductForm from './forms/new';
import ProductList from './list';

function Products() {
  return (
    <>
      <Outlet />
      <Routes>
        <Route path="*" element={<Navigate to="/catalogs/products" />} />
        <Route index element={<ProductList />} />
        <Route path="/new" element={<NewProductForm />} />
        <Route path=":id/edit" element={<EditProductForm />} />
      </Routes>
    </>
  );
}

export default Products;
